import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}

/* phase-3b8j-r1b-rubber-flex-type-card-dom-fix */
(function(){
  var path = window.location && window.location.pathname;
  if (path !== '/collections/rubber-flex-collets') return;
  var cards = [{"title":"Blind-Hole Expanding Rubber Collet Chucks","image":"https://cdn.shopify.com/s/files/1/0735/9542/0857/files/8c7788be3554ac1f868c62e3bbe2e772.png?v=1780802021"},{"title":"JAB-SK Air-Operated Rotary Rubber Collet Chucks","image":"https://cdn.shopify.com/s/files/1/0735/9542/0857/files/adba39614c41af1dec8226ed14411d56_9702797f-6182-40a3-9305-c338ba1686fe.png?v=1780806582"},{"title":"Multi-Spindle Rubber-Flex Collet Chucks","image":"https://cdn.shopify.com/s/files/1/0735/9542/0857/files/dbe1a410b4647f6d3173d37f4f712381_650f516f-cf20-4b4d-9a48-efab37e711d2.png?v=1780802167"},{"title":"Rubber-Flex Collets","image":"https://cdn.shopify.com/s/files/1/0735/9542/0857/files/06c6801a6b94169a88a7a1a401fb30ec_6f58e879-1330-495c-aae0-c11cec1a4be6.png?v=1780806448"},{"title":"Rubber-Flex Collet Bore Tools","image":"https://cdn.shopify.com/s/files/1/0735/9542/0857/files/b8607754ff676249d85b54ecd7645325_9aa35fe8-f9a9-403e-8015-ce205721ef3c.png?v=1780802223"},{"title":"Rubber-Flex Collet Changeover Tools","image":"https://cdn.shopify.com/s/files/1/0735/9542/0857/files/bfdbd107b8e9fd307a5e81375a62117f_c0b853e3-75d2-401c-87c5-6fba9712276e.png?v=1780802245"},{"title":"Rubber-Flex Collet Chucks with Inner Stop","image":"https://cdn.shopify.com/s/files/1/0735/9542/0857/files/43b689985d9b8d0b47d6fbe2181a9f3a_d6ccd8b3-bcf2-43d4-9ccc-e4e8e37ce481.png?v=1780802306"},{"title":"Blind-Hole Rubber-Flex Expanding Collets","image":"https://cdn.shopify.com/s/files/1/0735/9542/0857/files/1eb19af281aed4e4994d30bcbcea745f_7fc42f77-0a5f-43a5-a33a-e58f4a02617b.png?v=1780806743"}];
  function withWidth(url, width){ return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width; }
  function applyRubberFlexTypeCardImages(){
    var grid = document.querySelector('.rfc-card-grid');
    if (!grid) return;
    cards.forEach(function(card){
      var headings = grid.querySelectorAll('.rfc-card h3');
      for (var i = 0; i < headings.length; i += 1) {
        if ((headings[i].textContent || '').trim() !== card.title) continue;
        var article = headings[i].closest('.rfc-card');
        var img = article && article.querySelector('.rfc-card__media img');
        if (!img) return;
        img.src = withWidth(card.image, 520);
        img.srcset = withWidth(card.image, 352) + ' 352w, ' + withWidth(card.image, 520) + ' 520w';
        img.alt = card.title;
        img.setAttribute('data-phase3b8j-r1b', 'rubber-flex-type-card-fixed');
        return;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyRubberFlexTypeCardImages);
  else applyRubberFlexTypeCardImages();
  document.addEventListener('shopify:section:load', applyRubberFlexTypeCardImages);
})();
/* end phase-3b8j-r1b-rubber-flex-type-card-dom-fix */
